import { defineComponent as _defineComponent } from 'vue'
import { renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, normalizeStyle as _normalizeStyle, createCommentVNode as _createCommentVNode, toDisplayString as _toDisplayString, createTextVNode as _createTextVNode, resolveDynamicComponent as _resolveDynamicComponent, withCtx as _withCtx, createBlock as _createBlock, createElementVNode as _createElementVNode, normalizeClass as _normalizeClass } from "vue"

const _hoisted_1 = { class: "BasePdfStyle q-pa-56 full-width" }
const _hoisted_2 = { key: 2 }
const _hoisted_3 = { class: "bg-teal-white-20" }

import type { BasePdfStyleContents } from 'src/common/interfaces'

interface IProps {
  contents: BasePdfStyleContents
}


export default /*@__PURE__*/_defineComponent({
  __name: 'BasePdfStyle',
  props: {
    contents: {}
  },
  setup(__props: any) {



return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(__props.contents, (content, index) => {
      return (_openBlock(), _createElementBlock("div", { key: index }, [
        (content.type === 'margin')
          ? (_openBlock(), _createElementBlock("div", {
              key: 0,
              style: _normalizeStyle(`margin-bottom: ${content.value}`)
            }, null, 4))
          : (content.type === 'text')
            ? (_openBlock(), _createBlock(_resolveDynamicComponent(content.tag), { key: 1 }, {
                default: _withCtx(() => [
                  _createTextVNode(_toDisplayString(content.value), 1)
                ]),
                _: 2
              }, 1024))
            : (_openBlock(), _createElementBlock("table", _hoisted_2, [
                _createElementVNode("thead", null, [
                  _createElementVNode("tr", _hoisted_3, [
                    (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(content.columns, (column, columnIndex) => {
                      return (_openBlock(), _createElementBlock("th", {
                        key: columnIndex,
                        class: "fs-11px fw-600"
                      }, _toDisplayString(column.label), 1))
                    }), 128))
                  ])
                ]),
                _createElementVNode("tbody", null, [
                  (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(content.rows, (row, rowIndex) => {
                    return (_openBlock(), _createElementBlock("tr", {
                      key: rowIndex,
                      class: _normalizeClass(["fs-11px", [row.style === 'section-footer' ? 'fw-600 bg-cool-gray-40' : 'fw-500']])
                    }, [
                      (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(content.columns, (col, colIndex) => {
                        return (_openBlock(), _createElementBlock("td", { key: colIndex }, _toDisplayString(typeof col.format === 'function' ? col.format(row[col.field as string]) : row[col.field as string]!), 1))
                      }), 128))
                    ], 2))
                  }), 128))
                ])
              ]))
      ]))
    }), 128))
  ]))
}
}

})